class c extends HTMLElement {
  constructor() {
    super(), this.page = 1, this.skeleton = null, this.sectionId = this.getAttribute("section-id") || "", this.pageURL = this.getAttribute("page-url") || "", this.gridSelector = this.getAttribute("grid-selector") || "", this.nextPage = parseInt(this.getAttribute("next-page") || "1", 10), this.page = parseInt(this.getAttribute("page") || "1", 10), this.init(), this.onLoadMore = this.onLoadMore.bind(this), this.skeleton = document.querySelector("[data-product-grid-skeleton]");
  }
  init() {
    this.addEventListener("click", this.onLoadMore), !window.location.pathname.includes("search") && this.manualLoadMore();
  }
  async onLoadMore(t) {
    t.preventDefault();
    const i = t.target;
    if (!i) return;
    const e = i.hasAttribute("load-more") ? i : i.closest("a");
    e && (e.setAttribute("aria-disabled", "true"), this.fetchGrid(), this.nextPage !== 2 && this.updateURLHash(this.pageURL));
  }
  fetchGrid() {
    var i;
    const t = `${this.pageURL}`;
    (i = this.skeleton) == null || i.setAttribute("data-loading", "true"), fetch(t).then((e) => {
      e.ok && e.text().then((a) => {
        var l;
        const r = new DOMParser().parseFromString(a, "text/html"), n = r.querySelector("[product-grid]"), o = document.querySelector(this.gridSelector);
        o && n && this.appendProductsCardsToGrid(o, n);
        const s = document.querySelector("collection-paginate"), d = r.querySelector("collection-paginate");
        s && d && s.replaceWith(d), (l = this.skeleton) == null || l.setAttribute("data-loading", "false");
      });
    });
  }
  appendProductsCardsToGrid(t, i) {
    const e = i.children;
    if (e) {
      let a = !1;
      for (; e.length; ) {
        a = !1;
        for (let r = 0; r < t.children.length; r++)
          (t.children[r].getAttribute("data-key") === e[0].getAttribute("data-key") || !e[0].hasAttribute("data-key")) && (a = !0);
        a ? e[0].remove() : t.appendChild(e[0]);
      }
    }
  }
  updateURLHash(t) {
    history.replaceState({ page: this.page }, "", t);
  }
  manualLoadMore() {
    const t = this.querySelector("button[load-more]");
    setTimeout(() => {
      t && t.click();
    }, 300);
  }
}
window.customElements.define("collection-paginate", c);
export {
  c as CollectionPaginate
};
